import { Button, Input, Modal, message, Form, Checkbox, DatePicker } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import { strDate2Server } from "@extensions/convert";

const LicenseOrderKey = ({ companyId, accId, keyId, onClose }) => {
  const [form] = Form.useForm();
  const [keyData, setKeyData] = useState("");
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(null);
  const user = useSelector((s) => s.user);
  
  const getData = () => {    
    if (!keyId) return;    
    setLoading(true);
    serverFetch(`license/orderkey?companyId=${companyId}&accId=${accId}&keyId=${keyId}`)
      .then((data) => {
        setLoading(false);
        setKeyData(data.body || "");
        setItem(data);
        form.setFieldsValue({
          comment: data.comment || "",
          frozen: data.frozen || false,
          finDate: data.finDate ? dayjs(data.finDate) : null,
        });
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (accId && keyId) {
      getData();
    }
  }, [companyId, accId, keyId]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(keyData);
      message.success("Ключ скопирован в буфер обмена");
    } catch (err) {
      // Fallback для старых браузеров
      const textArea = document.createElement("textarea");
      textArea.value = keyData;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);
      message.success("Ключ скопирован в буфер обмена");
    }
  };

  const onValuesChange = (changedValues) => {
    setItem(prev => ({ ...prev, ...changedValues }));
  };

  const handleSave = () => {
    if (!item) return;

    setLoading(true);
    serverFetch(`license/key`, {
      method: "PUT",
      bodyData: {
        ...item,
        companyId,
        accId,
        id: keyId,
        finDate: item.finDate ? strDate2Server(item.finDate) : null,
      }
    })
      .then(() => {
        setLoading(false);
        message.success("Ключ обновлен");
        onClose(true);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const handleClose = () => {
    setKeyData("");
    setItem(null);
    form.resetFields();
    onClose();
  };

  return (
    <Modal title={`Ключ лицензии ${companyId} / ${accId} / ${keyId}`} open={true} onCancel={handleClose}
      footer={[
        <Button key="close" onClick={handleClose}>Закрыть</Button>,
        <Button key="copy" type="default" onClick={handleCopy} disabled={!keyData}>Копировать</Button>,
        <Button key="save" type="primary" onClick={handleSave} loading={loading}>Сохранить</Button>,
      ]}
      width={600}
      className="cloud-modal-license-order-key"
    >
      <div className="cloud-modal-content">
        <Input.TextArea value={keyData} readOnly rows={6} placeholder="Загрузка ключа..." style={{ fontFamily: 'monospace', fontSize: '12px', marginBottom: 16 }}/>        
        <Form form={form} onValuesChange={onValuesChange} layout="vertical" disabled={loading}>
          <Form.Item label="Комментарий" name="comment"><Input.TextArea rows={3} placeholder="Введите комментарий" /></Form.Item>          
          <Form.Item label="Заморожен" name="frozen" valuePropName="checked"><Checkbox>Ключ заморожен</Checkbox></Form.Item>          
          {user?.admin && (
            <Form.Item label="Дата окончания" name="finDate"><DatePicker format="DD.MM.YYYY" placeholder="Выберите дату окончания" style={{ width: '100%' }} allowClear /></Form.Item>
          )}
        </Form>
      </div>
    </Modal>
  );
};

export default LicenseOrderKey;
